<template>
  <div class="no-account">
    <div class="banner">
      <div class="title">
        <div class="tips"> {{type == 1 ? '提现设置':'入网签约设置'}}</div>
        <div class="line"></div>
      </div>
    </div>
    <div class="card">
      <van-button
        class="button" 
        type="primary" 
        color="linear-gradient(85deg, #FF6A59 0%, #FF8059 100%)"
        @click="bindingAccount"
      >
        {{type == 1 ? '绑定提现人':'授权入网操作人员'}}
      </van-button>
      <div class="tips">ps：先绑定成为{{type == 1 ? '提现':'入网签约'}}人，再进行{{type == 1 ? '提现':'入网签约'}}操作</div>
      <p class="text" v-if="type == 1">
        特别提示：<br />
        1、提现人绑定<br />
        点击“绑定提现人”，选择要绑定的职员，向经销商要授权验证码，输入授权验证码即可完成绑定。<br />
        2、绑定提现授权验证码说明<br />
        绑定提现人时，系统以短信的方式，向经销商（老板）预留在公司建店档案上的手机号发送授权验证码。<br />
        3、更换提现人<br />
        经理或店长角色，可随时点击“取消绑定”更换提现人（先取消当前绑定的提现人，才能绑定新的提现人）。<br />
        4、风险提醒<br />
        提现人绑定成功后，该提现人可在“提现”菜单中自由提现，系统不再向经销商（老板）发送提现验证码，请谨慎绑定提现人。<br />
      </p>
      <p class="text" v-else>
        温馨说明：<br />
        什么情况下需要用到【授权入网操作人员】操作？<br />
        店面的《营业执照》上注明的法人本人，不能或不想亲自操作“银联商户号入网申请”；才需要授权店面其它人员，帮助营业执照上的法人，完成“银联商户号入网申请”操作。若授权，一切风险店面自己承担！<br />
        一、【授权入网操作人员】的操作步骤：<br />
        第1步：拓客宝中店长或经销商角色，点击【授权入网操作人员】按钮，选择授权人员，点【确定】<br />
        第2步：在弹出的授权窗口中，点击【获取验证码】，此时系统会以短信的方式，向经销商（老板）预留在公司建店档案上的手机号，发送授权验证码。<br />
        第3步：输入授权验证码，点【确定】即完成授权。此时授权人才可以代替法人进行商户号入网资料提交。<br />
        二、如何取消已授权的入网操作人员？<br />
        拓客宝系统中的经销商或店长角色，随时点击该页面上的“取消授权”即可取消授权。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  methods: {
    bindingAccount() {
      this.$emit('bindingAccount')
    }
  }
}
</script>

<style lang="stylus" scoped>
.no-account {
  display: flex;
  flex-direction: column;
  align-items center;
  .banner {
    width: 375px;
    height: 318px;
    background: url('~@/assets/images/role-banner.png');
    background-size: 100% 100%;
    overflow hidden
    .title {
      margin-top: 87px;
      margin-left: 37px;
      .tips {
        color: #FFFFFF;
        font-size: 32px;
        font-weight: bold;
      }
      .line {
        width: 46px;
        height: 2px;
        margin-top: 25px;
        background: #F7F8F8;
      }
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 329px;
    height: 480px;
    background: #FFFFFF;
    box-shadow: 1px 3px 11px 1px rgba(187,187,187,0.4);
    border-radius: 17px;
    margin-top: -108px;
    .button {
      width: 185px;
      margin-top: 60px;
      border-radius: 20px 20px 20px 18px;
    }
    .tips {
      font-size: 12px;
      color: #FF6B31;
      margin-top: 20px;
    }
    .text {
      padding: 0 10px;
      color #777
      font-size 12px
      line-height 18px
    }
  }
}
</style>